import lock from '../images/lockpage.png'
export default function LockPage() {
    function onClick(): void{
        window.location.href = '/login'
    }
    return (
        <div>
            <div className='mt-4 text-lg font-medium'>Bạn phải <span className='font-bold text-[#0277bd] cursor-pointer' onClick={onClick}>đăng nhập</span> để sử dụng chức năng này</div>
            <div className="lock-image w-full mt-4 mb-4 flex justify-center">
                <img src={lock} alt="" width='40%' />
            </div>
        </div>
    )
}